import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemGlobalPermissionsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-global-permissions',
	path: '/secure/admin/jira/GlobalPermissions!default.jspa',
};
